import { useTranslation } from "react-i18next";

import { Table } from "@mui/material";
import { ExpanderComponentProps } from "react-data-table-component";

interface Row {
  sNo: string;
  studentName: string;
  courseName: string;
  batchName: string;
  level: string;
  levelStaus: string;
  certificateStatus: string;
  payDue: string;
}

interface IProps extends ExpanderComponentProps<Row> {
  // currently, props that extend ExpanderComponentProps must be set to optional.
}

const PaymentSettlementExpandedTable: React.FC<IProps> = (props: any) => {
  const { data } = props;

  const { t } = useTranslation();

  return (
    <div>
      <Table
        className="dark-table"
        sx={{
          "& > thead > tr > th:nth-child(n + 1), & > tbody > tr > td:nth-child(n + 1)":
            { textAlign: "center" },
          '& > tbody > tr:nth-child(odd) > td, & > tbody > tr:nth-child(odd) > th[scope="row"]':
            {
              borderBottom: 0,
            },
        }}
      >
        <thead>
          <tr className="r-green tableHeading">
            <th>{t("sNo")}</th>
            <th>{t("invoiceNo")} </th>
            <th>{t("studentName")} </th>
            <th>{t("invoiceMonth")} </th>
            <th>{t("itemName")} </th>
            <th>{t("invoiceAmt")}</th>
          </tr>
        </thead>
        <tbody>
          {data.studentList.map((item: any, index: any) => (
            <tr
              key={item.invoiceNumber}
              className="border-down"
              style={{ lineHeight: "2.5rem" }}
            >
              <th scope="row">{index + 1}</th>
              <td>{item.invoiceNumber}</td>
              <td>{item.studentName}</td>
              <td>{item.forMonth}</td>
              <td>{item.itemName}</td>
              <td>{item.netPayableAmount}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PaymentSettlementExpandedTable;
